import React, { useState, useEffect } from "react";
import TableCellRank from "../table/TableCellRank";
import TableSkeleton from "../table/TableSkeleton";
import Link from "next/link";
import Image from "next/image";
import { MatchupHomeAwaySelect } from "./Constants";

const tableHeader = [
  {
    title: "Key Stats",
    showImage: false,
    sortable: false,
    key: "KeyStats",
  },
];

export const KeyStats = ({
  teamName,
  opponentName,
  revertDefense,
  teamKeys,
  isHome,
  leagueFromUrl,
  leagueYear,
  isPremiumPlan,
  conferenceTeamCount = 0,
}) => {
  const [dataLoaded, setDataLoaded] = useState(null);
  const [isConferenceOnly, setIsConferenceOnly] = useState(false);
  const [dataToShow, setDataToShow] = useState(null);
  const [homeAwayFilter, setHomeAwayFilter] = useState({ value: "Default", label: "Default" });

  const rankConfig = {
    leagueType: leagueFromUrl,
  };

  useEffect(() => {
    if (teamKeys?.teamName?.data?.length && teamKeys?.opponentName?.data?.length) {
      setDataLoaded(true);
    }
  }, [teamKeys]);

  useEffect(() => {
    if (teamKeys?.opponentName?.data?.length && teamKeys?.teamName?.data?.length) {
      if (homeAwayFilter.value === "Home" && isConferenceOnly) {
        setDataToShow({
          team: teamKeys?.teamName?.home_conf_data,
          opponent: teamKeys?.opponentName?.home_conf_data,
        });
      } else if (homeAwayFilter.value === "Away" && isConferenceOnly) {
        console.log("away conf data");
        setDataToShow({
          team: teamKeys?.teamName?.away_conf_data,
          opponent: teamKeys?.opponentName?.away_conf_data,
        });
      } else if (homeAwayFilter.value === "Home") {
        setDataToShow({ team: teamKeys?.teamName?.home_data, opponent: teamKeys?.opponentName?.home_data });
      } else if (homeAwayFilter.value === "Away") {
        setDataToShow({ team: teamKeys?.teamName?.away_data, opponent: teamKeys?.opponentName?.away_data });
      } else if (isConferenceOnly) {
        setDataToShow({ team: teamKeys?.teamName?.conf_data, opponent: teamKeys?.opponentName?.conf_data });
      } else {
        setDataToShow({ team: teamKeys?.teamName?.data, opponent: teamKeys?.opponentName?.data });
      }
    }
  }, [isConferenceOnly, teamKeys, revertDefense, homeAwayFilter]);

  const handleCheckboxClick = (e) => {
    isConferenceOnly ? setIsConferenceOnly("") : setIsConferenceOnly(e);
  };

  return (
    <div key={`key_${teamName}`}>
      {!dataLoaded ? (
        <TableSkeleton
          tableHeader={tableHeader}
          tableRowsCount={10}
          className="table-space matchup-output-lazyloading"
          tableHeaderHeight="90px"
        ></TableSkeleton>
      ) : null}
      {dataLoaded ? (
        <>
          <Link
            href={`/team/${leagueFromUrl}/${leagueYear}/${isHome ? teamName : opponentName}`}
            target="_blank"
            className="scores-team-name-link"
          >
            <h3 className="text-center">{isHome ? teamName : opponentName}</h3>
          </Link>
          <table className="table tl-fixed-desktop">
            <thead>
              <tr className="text-center">
                <th colSpan={3} className="text-right">
                  <div className="d-flex justify-content-between">
                    <span className="mr-2 text-left" style={{ fontSize: "1.2rem" }}>
                      Key Stats
                    </span>
                    <div className="d-inline-flex align-items-center">
                      <input
                        type="checkbox"
                        id={`keyConferenceOnlyCheck_${revertDefense ? opponentName : teamName}`}
                        onClick={() => {
                          handleCheckboxClick(teamName);
                        }}
                      />
                      <label
                        className="mb-0 ml-2 mr-2"
                        style={{ whiteSpace: "pre", fontSize: "1rem", fontWeight: 600 }}
                        htmlFor={`keyConferenceOnlyCheck_${revertDefense ? opponentName : teamName}`}
                      >
                        Conference only
                      </label>
                      <MatchupHomeAwaySelect homeAwayFilter={homeAwayFilter} setHomeAwayFilter={setHomeAwayFilter} />
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="table-header-wrap">
                  <div className="d-flex">
                    <Image
                      className="teamLogoMiniWrapper"
                      height={24}
                      width={24}
                      alt="team logo"
                      src={`http://shotqualitybets.com/static/media/logos/${
                        revertDefense ? opponentName : teamName
                      }.png`}
                      style={{
                        marginRight: "8px",
                      }}
                    />
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      Offensive
                    </span>
                  </div>
                </td>
                <td></td>
                <td className="d-flex align-items-center justify-content-end table-header-wrap">
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: 600,
                    }}
                  >
                    Defensive
                  </span>
                  <div
                    className="teamLogoMiniWrapper"
                    style={{
                      marginLeft: "8px",
                    }}
                  >
                    <Image
                      height={24}
                      width={24}
                      alt="team logo"
                      src={`http://shotqualitybets.com/static/media/logos/${
                        revertDefense ? teamName : opponentName
                      }.png`}
                    />
                  </div>
                </td>
              </tr>
              {dataToShow &&
                dataToShow.team.map((item, i) => {
                  if (dataToShow.opponent.length <= i || (item.Name === "Rim and 3 SQ PPP" && !isPremiumPlan)) {
                    return null;
                  }

                  return (
                    <tr key={`${teamName}${item.Name}`}>
                      <TableCellRank
                        rankValue={revertDefense ? dataToShow.opponent[i]["Offensive rank"] : item["Offensive rank"]}
                        {...rankConfig}
                        conferenceTeamCount={isConferenceOnly ? conferenceTeamCount : 0}
                      >
                        <b>{revertDefense ? dataToShow.opponent[i]["Offensive"] : item["Offensive"]}</b>
                        <div
                          style={{
                            fontSize: "0.8rem",
                          }}
                        >
                          {["Shot Selection", "Spacing", "Shot Making"].includes(item.Name) ? " %tile" : ""}
                        </div>
                      </TableCellRank>

                      <td className="text-center">{item.Name}</td>
                      <TableCellRank
                        rankValue={revertDefense ? item["Defensive rank"] : dataToShow.opponent[i]["Defensive rank"]}
                        {...rankConfig}
                        conferenceTeamCount={isConferenceOnly ? conferenceTeamCount : 0}
                      >
                        <b>{revertDefense ? item["Defensive"] : dataToShow.opponent[i]["Defensive"]}</b>
                        <div
                          style={{
                            fontSize: "0.8rem",
                          }}
                        >
                          {["Shot Selection", "Spacing", "Shot Making"].includes(item.Name) ? " %tile" : ""}
                        </div>
                      </TableCellRank>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </>
      ) : null}
    </div>
  );
};
